import { render, staticRenderFns } from "./live3.vue?vue&type=template&id=755daaf4&scoped=true"
import script from "./live3.vue?vue&type=script&lang=js"
export * from "./live3.vue?vue&type=script&lang=js"
import style0 from "./live3.vue?vue&type=style&index=0&id=755daaf4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755daaf4",
  null
  
)

export default component.exports